import { SeekPassIconVerified } from '@seek/certsy-ui';
import { useTranslations } from '@vocab/react';
import { Text, TooltipRenderer, Box } from 'braid-design-system';

import translations from './.vocab';

export const VerifiedBySeekPassIcon = ({
  id,
  title,
}: {
  id: string;
  title: string;
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box display="flex">
      <TooltipRenderer
        id={`certsy-verified-indicator-tooltip-${id}`}
        tooltip={<Text>{t('Verified by SEEK Pass')}</Text>}
      >
        {({ triggerProps }) => (
          <Box
            {...triggerProps}
            aria-label={title ? undefined : t('Verified by SEEK Pass')}
          >
            <Text weight="strong">
              {title} <SeekPassIconVerified />
            </Text>
          </Box>
        )}
      </TooltipRenderer>
    </Box>
  );
};
